import styles from './MerchantLogo.module.scss';

import React from 'react';

import { useMerchant } from 'hooks/context/merchant';
import { ReactComponent as Logo } from 'routes/Menu/BusinessInfo/defaultLogo.svg';
import { Shimmer } from 'routes/Menu/BusinessInfo/Shimmer';
import clsx from 'clsx';

type MerchantLogoProps = {
  size?: string;
}

export const MerchantLogo: React.FC<MerchantLogoProps> = ({ size }) => {
  const { merchant, isLoading } = useMerchant();

  if (isLoading) return <Shimmer />;

  if (!merchant) return <div className={styles.info} />;

  const { logo } = merchant;

  return (
      <span className={clsx(styles.logo, { [styles.medium] : size?.includes('medium') })}>
        {logo ? <img src={logo} alt="" data-testid={'merchant-logo'} /> : <Logo />}
      </span>
  );
};
